import { createBaseClient } from './base.client';
import { INSTANCE_URL } from '@/config/env';

/**
 * Auth API Client
 * Configured for user authentication and registration
 * Base URL: INSTANCE_URL/auth
 */
export const auth = createBaseClient(`${INSTANCE_URL}/auth`, 'auth');
